import { render, staticRenderFns } from "./YourCertificate.vue?vue&type=template&id=32ffa33a&scoped=true&"
import script from "./YourCertificate.vue?vue&type=script&lang=js&"
export * from "./YourCertificate.vue?vue&type=script&lang=js&"
import style0 from "./YourCertificate.vue?vue&type=style&index=0&id=32ffa33a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ffa33a",
  null
  
)

export default component.exports